/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type { ServiceFeeList } from './types';

enum Api {
  individualProxyFee = '/front-end/proxy-order-manager/list', // 个体税金及服务费列表
  orderExport = '/front-end/proxy-order-export/orderExport', // 订单导出
  batchDownload = '/front-end/proxy-receipt-download/batchDownload' // 批量下载回单
}

export const serviceFeeList: ServiceFeeList = params => {
  return http.request({
    url: Api.individualProxyFee,
    method: 'POST',
    params: {
      ...params
    }
  });
};

export const orderExport = (params: { exportType: number; reqParam: any }) =>
  http.download({
    url: Api.orderExport,
    method: 'POST',
    params
  });

export const batchDownload = (params: {
  downloadType: number; //downloadType ： 901, "代办供应商-订单管理-批量下载回单"
  queryParam: any;
}) =>
  http.request({
    url: Api.batchDownload,
    method: 'POST',
    params
  });
